module.exports = __webpack_public_path__ + "static/media/intro.0ab527f9.jpg";